import { queueAnalyticsEvent, SeoEvent } from 'lib/gtm'

export const pageViewSeo = (url: string) => {
  const eventData = {
    event: SeoEvent.PAGE_VIEW,
    page_location: url,
    page_title: document.title,
    send_page_view: false
  }

  queueAnalyticsEvent(eventData, true)
}
